import React from 'react';
import '../css/fragments.css';
import T from  '../lib/translator';
import Timer from './timer';
import { registered } from '../lib/api';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import BookSearch from './BookSearch';

export const getAbsolutePosition = (playlist, track, position) => {
    //console.log("getAbsolutePosition(" + track + ", " + position + ")");
    try {
        let offset = 0;
        for (let i = 0; i < track; i++) {
            offset += playlist[i].length;
        }
        return offset + (position / 1000);
    } catch(error) {
        return 0;
    }
}

const Fragments = ({currentTrack, playTrack, playlist, bookmarks, removeBookmark, book}) => {
    const [tab, setTab] = React.useState(0);
    const [search, setSearch] = React.useState([]);
    const [cue, setCue] = React.useState([]);

    React.useEffect(() => {
        var pl = [];
        switch(tab) {
            case 0:                
                setCue(playlist.map((_, i) => {return {track: i, position: 0, timer: _.length, label: T('Фрагмент') + ' ' + (i + 1)};}));
            break;
            case 1:
                setCue(bookmarks.map((_, i) => {return {track: _.track, timer: getAbsolutePosition(playlist, _.track, _.position), position: _.position, label: T('Закладка') + ' ' + (i + 1)};}));
            break;
            case 2:
                setCue([]);
            break;
            default:
        }
    }, [tab, playlist, bookmarks]);

    return (
        <div className='fragmentsContainer'>
            <div className='fragmentsHeader'>
                <button aria-label={T('Фрагменты') + ' (' + playlist.length + ')' + (tab === 0 ? ' выбрано.' : '')} onClick={() => setTab(0)} className={tab === 0 ? 'fragmentsTitle fragmentsActive' : 'fragmentsTitle'}>{T('Фрагменты') + ' (' + playlist.length + ')'}</button>
                {registered() && <button aria-label={T('Закладки') + ' (' + bookmarks.length + ')' + (tab === 1 ? ' выбрано.' : '')} onClick={() => setTab(1)} className={tab === 1 ? 'fragmentsTitle fragmentsActive' : 'fragmentsTitle'}>{T('Закладки') + ' (' + bookmarks.length + ')'}</button>}
                {registered() && <button aria-label={T('Поиск по тексту книги')} onClick={() => setTab(2)} style={{maxWidth: '32px'}} className={tab === 2 ? 'fragmentsTitle fragmentsActive' : 'fragmentsTitle'}><ManageSearchIcon color={tab === 2 ? 'black' : 'gray'} sx={{height: 32}}/></button>}
            </div>
            {tab === 2 && <BookSearch playlist={playlist} book={book} search={cue} setSearch={setCue} />}
{/*
            <div className='fragments'>
                <table border={0} style={{borderCollapse: 'collapse', flex: 1, width: '100%'}}>
                    <tbody>{(tab === 0 ? playlist : (tab === 1 ? bookmarks : search)).map((_, i) => {return (
                        <tr key={i} style={tab === 0 && currentTrack === i ? {backgroundColor: '#00aec7'} : {}} >
                            <td
                                data-track={tab === 0 ? i : _.track}
                                data-position={tab === 0 ? 0 : _.position}
                                onClick={(function(i) {return function() {playTrack(tab === 0 ? i : (tab === 1 ? bookmarks[i].track : search[i].track), tab === 0 ? 0 : (tab === 1 ? bookmarks[i].position : search[i].position));};})(i)} 
                                >{registered() ? (tab === 0 ? T('Фрагмент') + ' ' + (i + 1) : (tab === 1 ? T('Закладка') + ' ' + (i + 1) : _.label)) : T('Ознакомительный фрагмент')}</td>
                            <td
                                data-track={tab === 0 ? i : _.track}
                                data-position={tab === 0 ? 0 : _.position}
                                onKeyDown={(e) => {if (e.key === 'Enter') playTrack(e.target.getAttribute('data-track'), e.target.getAttribute('data-position'));}}
                                key={i+1} 
                                //onClick={(function(i) {return function() {console.log("track: " + bookmarks[i].track); console.log("position: " + bookmarks[i].position); playTrack(tab === 0 ? i : bookmarks[i].track, tab === 0 ? 0 : bookmarks[i].position / 1000);};})(i)} 
                                onClick={(e) => {console.log(e); playTrack(e.target.getAttribute('data-track'), e.target.getAttribute('data-position'));}}
                                tabIndex={0} 
                                aria-label={(tab === 0 ? T('Фрагмент') : T('Закладка'))+ ' ' + (i + 1)}
                                align='right'><Timer value={tab === 0 ? _.length : getAbsolutePosition(_.track, _.position)}/></td>
                                {tab === 1 && <td width={16}><button data-track={_.track} data-position={_.position} aria-label={T('Удалить закладку')} onClick={_=>removeBookmark(_.target.getAttribute('data-track'), _.target.getAttribute('data-position'))} style={{border: 0, backgroundColor: 'transparent'}}>❌</button></td>}
                        </tr>);})}
                    </tbody>
                </table>
            </div>
*/}
            <div className='fragments'>
                <table border={0} style={{borderCollapse: 'collapse', flex: 1, width: '100%'}}>
                    <tbody>{cue.map((_, i) => {return (
                        <tr 
                            key={i}
                            style={tab === 0 && currentTrack === i ? {backgroundColor: '#00aec7'} : {}}
                            tabIndex={0}
                            aria-label={_.label}
                            onKeyDown={(e) => {if (e.key === 'Enter') playTrack(_.track, _.position / 1000);}}
                            onClick={() => playTrack(_.track, _.position / 1000)}
                        >
                            <td>{registered() ? _.label : T('Ознакомительный фрагмент')}</td>
                            <td align='right'>{_.length}<Timer value={_.timer}/></td>
                            {tab === 1 && <td width={16}><button data-track={_.track} data-position={_.position} aria-label={T('Удалить закладку')} onClick={_=>removeBookmark(_.target.getAttribute('data-track'), _.target.getAttribute('data-position'))} style={{border: 0, backgroundColor: 'transparent'}}>❌</button></td>}
                        </tr>);})}
                    </tbody>
                </table>
            </div>

        </div>
    )
};

export default Fragments;